// Carry Roll UnitsSwitch — distance/speed/height selectors (11.1).

import { UnitToggle } from 'calc-controls';
import { useStore } from '../../store';
import type { DistanceUnit, HeightUnit, SpeedUnit } from '@carry-roll/shared-logic';

export function UnitsSwitch() {
  const { distanceUnit, speedUnit, heightUnit, setUnits } = useStore((s) => ({
    distanceUnit: s.distanceUnit,
    speedUnit: s.speedUnit,
    heightUnit: s.heightUnit,
    setUnits: s.setUnits,
  }));

  return (
    <div data-testid="units-switch" className="grid gap-3">
      <UnitToggle
        label="Distance"
        value={distanceUnit}
        onChange={(v) => setUnits({ distanceUnit: v as DistanceUnit })}
        options={[
          { label: 'yd', value: 'yd' },
          { label: 'm', value: 'm' },
        ]}
      />
      <UnitToggle
        label="Speed"
        value={speedUnit}
        onChange={(v) => setUnits({ speedUnit: v as SpeedUnit })}
        options={[
          { label: 'mph', value: 'mph' },
          { label: 'kph', value: 'kph' },
        ]}
      />
      <UnitToggle
        label="Height"
        value={heightUnit}
        onChange={(v) => setUnits({ heightUnit: v as HeightUnit })}
        options={[
          { label: 'ft', value: 'ft' },
          { label: 'm', value: 'm' },
        ]}
      />
    </div>
  );
}
